module.exports = __webpack_public_path__ + "static/media/header-coachTracker-small.782b04ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-coachTracker-small.svg
// module id = 157
// module chunks = 0